import { IConcernCategoryHook } from '@models';
import { ConcernService } from '@services';
import { useStore } from '@stores';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

export const useConcernCategories = (): IConcernCategoryHook => {
  const { concernStore } = useStore();
  const {
    concernCategories,
    skipCount,
    currentPage,
    totalCount,
    maxResultCount,
    loading,
    handlePageChange,
  } = concernStore;
  const [name, setName] = useState<string>('');

  useEffect(() => {
    concernStore.getAllCategories({
      name,
      maxResultCount,
      skipCount,
    });
  }, [concernStore, name, maxResultCount, skipCount]);

  const handleNameSearch = debounce((text: string) => {
    setName(text);
    concernStore.setSkipCount(0);
    concernStore.setCurrentPage(1);
  }, 500);

  const fetchAllForExport = useCallback(async () => {
    const result = await ConcernService.getAllCategories({
      name,
      maxResultCount: totalCount || 10000,
      skipCount: 0,
    });
    return result.items;
  }, [name, totalCount]);

  return {
    loading,
    dataSource: Array.from(concernCategories.values()),
    totalCount,
    currentPage,
    handleNameSearch,
    handlePageChange,
    fetchAllForExport,
  };
};
